import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../api/client";

export default function MotDePasseOublie() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async () => {
    setError(""); setMsg("");
    if (!email.trim()) { setError("Indiquez votre email."); return; }
    setBusy(true);
    try {
      const r = await api.post("/auth/forgot-password", { email: email.trim() });
      setMsg(r.message || "Si un compte est associé à cet email, un code vous a été envoyé.");
    } catch (e) {
      setError(e.message || "Une erreur est survenue.");
    } finally { setBusy(false); }
  };

  return (
    <div className="container" style={{ maxWidth: 460 }}>
      <h1>Mot de passe oublié</h1>
      <p className="muted mb-3">
        Indiquez l'email de votre compte. Si un compte existe, un code de
        réinitialisation vous sera envoyé.
      </p>
      <div className="card">
        {error && <div className="error">{error}</div>}
        {msg ? (
          <>
            <div className="success">{msg}</div>
            <p className="mt-2">
              Une fois le code reçu, cliquez ci-dessous pour saisir le code et
              définir un nouveau mot de passe.
            </p>
            <button onClick={() =>
              nav(`/reinitialiser-mot-de-passe?email=${encodeURIComponent(email)}`)}>
              Saisir mon code
            </button>
            <p className="muted mt-2">
              <Link to="/connexion">← Retour à la connexion</Link>
            </p>
          </>
        ) : (
          <>
            <div className="field"><label>Email</label>
              <input type="email" value={email}
                     onChange={(e) => setEmail(e.target.value)}
                     onKeyDown={(e) => e.key === "Enter" && submit()} /></div>
            <button onClick={submit} disabled={busy}>
              {busy ? "Envoi…" : "Envoyer le code"}
            </button>
            <p className="muted mt-2">
              <Link to="/connexion">← Retour à la connexion</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
